export default __webpack_public_path__ + "static/media/master-card.0dcf336b.png";